import React from 'react';

import { type PatientImportJobStatus } from '@eluve/api-contract';
import { Tag, type TagProps } from '@eluve/components';

const STATUS_TONE: Record<PatientImportJobStatus, TagProps['color']> = {
  PARSING: 'lightblue',
  VALIDATING: 'lightblue',
  HEADER_MISMATCH: 'negative',
  REVIEW_READY: 'warning',
  COMMITTING: 'lightblue',
  COMPLETED: 'positive',
  PARTIALLY_COMPLETED: 'orange',
  CANCELLED: 'gray',
  FAILED: 'negative',
};

export const StatusTag: React.FC<{ status: PatientImportJobStatus }> = ({
  status,
}) => (
  <Tag
    color={STATUS_TONE[status]}
    size="xs"
    label={status.replaceAll('_', ' ')}
  />
);
